module.exports = __webpack_public_path__ + "img/warning.8a23fb14.svg";